import {
  getJson,
  postJson,
  patchJson,
  putJson,
  del
} from '../fetch';
import { stringifyURLParams, triggerFileDownload } from '../util';
import API_BASE_PATH from './basePath';

export const getSurveys = (
  states = [],
  page,
  size,
  type,
  listingType,
  optionalParameters = {}
) => {
  const stateFlags = Object.fromEntries(states.map((s) => [s, 1]));

  const params = stringifyURLParams(
    {
      ...stateFlags, page, size, type, listingType, ...optionalParameters
    }
  );
  return getJson(`${API_BASE_PATH}/surveys?${params}`);
};

export const getUserSurveys = () => getJson(`${API_BASE_PATH}/surveys?listingType=FOR_PARTICIPANT&page=0&size=999`);

export const getSurvey = (surveyId) => getJson(`${API_BASE_PATH}/surveys/${surveyId}`);

export const getSurveyForEdit = (surveyId) => getJson(`${API_BASE_PATH}/surveys/${surveyId}/edit`);

export const postSurvey = (surveyData) => postJson(`${API_BASE_PATH}/surveys`, surveyData);

export const putSurvey = (surveyData) => putJson(`${API_BASE_PATH}/surveys/${surveyData.id}`, surveyData);

export const postSurveyResponse = (surveyId, responseData) => postJson(`${API_BASE_PATH}/surveys/${surveyId}/responses`, responseData);

export const getSurveyResponseForUser = (surveyId) => getJson(`${API_BASE_PATH}/surveys/${surveyId}/responses`);

export const checkForResponse = (surveyId) => getJson(`${API_BASE_PATH}/surveys/${surveyId}/responses?onlyStatus=1`);

export const getSurveyMetadata = (surveyId) => getJson(`${API_BASE_PATH}/surveys/${surveyId}/metadata`);

export const getSurveyStats = (surveyId) => getJson(`${API_BASE_PATH}/surveys/${surveyId}/stats`);

export const markFeedbackAsViewed = (surveyId) => postJson(`${API_BASE_PATH}/surveys/${surveyId}/stats`, undefined);

export const getSurveyInfo = (surveyId) => getJson(`${API_BASE_PATH}/surveys/${surveyId}/info`);

export const patchSurveyCourseParticipantsUpdate = (surveyId) => patchJson(`${API_BASE_PATH}/surveys/${surveyId}/course-participants`);

export const getSurveyResults = (surveyId) => getJson(`${API_BASE_PATH}/surveys/${surveyId}/results`);

export const postSurveyMessage = (surveyId, data) => postJson(`${API_BASE_PATH}/surveys/${surveyId}/messages`, data);

export const getSurveyResponseTimeLeft = (surveyId) => getJson(`${API_BASE_PATH}/surveys/${surveyId}/response-time`);

export const getSurveyMessages = (surveyId) => getJson(`${API_BASE_PATH}/surveys/${surveyId}/messages`);

export const getSurveyReminders = (surveyId) => getJson(`${API_BASE_PATH}/surveys/${surveyId}/reminders`);

export const sendSurveyNotification = (surveyId, data) => postJson(`${API_BASE_PATH}/surveys/${surveyId}/notifications`, data);

export const getSurveyParticipants = (surveyId) => getJson(`${API_BASE_PATH}/surveys/${surveyId}/participants`);

export const postSurveyParticipants = (surveyId, participants) =>
  postJson(`${API_BASE_PATH}/surveys/${surveyId}/participants`, participants);

export const deleteCourseUnitRealisation = (surveyId, id) => del(`${API_BASE_PATH}/surveys/${surveyId}/course-realisations/${id}`);

export const getSurveySchedule = (surveyId) => getJson(`${API_BASE_PATH}/surveys/${surveyId}/schedules`);

export const endSurvey = (surveyId) => postJson(`${API_BASE_PATH}/surveys/${surveyId}/schedules?end=true`);

export const addSurveySchedule = (surveyId, data) => postJson(`${API_BASE_PATH}/surveys/${surveyId}/schedules`, data);

export const patchSurveySchedule = (surveyId, data) => patchJson(`${API_BASE_PATH}/surveys/${surveyId}/schedules`, data);

export const exportSurveyData = async (surveyId, includeSensitiveData = false, exportReason = '') => {
  const url = `${API_BASE_PATH}/surveys/${surveyId}/exports/responses`;
  const data = {
    includeSensitiveData,
    exportReason
  };

  const response = await postJson(url, data, true, true);

  // Parse the response
  const blob = await response.blob();
  const disposition = response.headers.get('content-disposition');
  const filename = disposition ? disposition.split('filename=')[1].replaceAll('"', '') : 'export.xlsx';

  triggerFileDownload(blob, filename);
};

export const downloadOpenQuestionResponsesExport = (surveyId) => {
  window.open(
    `${API_BASE_PATH}/surveys/${surveyId}/exports/open-question-responses`,
    '_self'
  );
};
